import axiosInstance from "../services/axiosComman";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { useQueryClient } from "@tanstack/react-query";

function useDeleteData() {
  const queryClient = useQueryClient();
  const handleDelete = async ({
    url = "",
    id = "",
    value = "",
    fetcher = () => {},
    data = "",
  }) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to Delete ${value}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Delete",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const config = data ? { data } : {};
          const response = await axiosInstance.delete(url, config);

          const successMessage =
            response.data.msg ||
            response.data.message ||
            "Data Deleted successfully";
          const isSuccess =
            response.data.status ||
            successMessage === "Data Deleted Successfully";

          if (isSuccess) {
            fetcher();
            toast.success(<p className="text-sm">{successMessage}</p>);
            queryClient.invalidateQueries({ queryKey: ["alerts"] });
          } else {
            const errorMessage =
              response.data.msg ||
              response.data.message ||
              "Failed to delete data";
            toast.error(<p className="text-sm">{errorMessage}</p>);
          }
        } catch (error) {
          if (!error.response) {
            toast.error(
              <p className="text-sm">
                {`CORS Error: Unable to connect to the server. Please check server CORS settings.`}
              </p>
            );
          } else {
            const errorMessage =
              error.response.data?.msg ||
              error.response.data?.message ||
              error.response.data?.error ||
              "An unexpected error occurred";
            toast.error(<p className="text-sm">{errorMessage}</p>);
          }
        }
      }
    });
  };

  return { handleDelete };
}

function useDeleteData2() {
  const queryClient = useQueryClient();
  const handleDelete = async ({
    url = "",
    label = "",
    onSuccess = () => {},
  }) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to delete ${label}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Delete",
    }).then(async (result) => {
      if (!result.isConfirmed) return;

      try {
        const response = await axiosInstance.delete(url);

        const message =
          response.data?.msg ||
          response.data?.message ||
          "Data deleted successfully";

        if (response.data?.status === true) {
          toast.success(<p className="text-sm">{message}</p>);
          onSuccess();
          queryClient.invalidateQueries({ queryKey: ["alerts"] });
        } else {
          const errorMessage =
            response.data?.msg || response.data?.message || "Delete failed";
          toast.error(<p className="text-sm">{errorMessage}</p>);
        }
      } catch (error) {
        if (!error.response) {
          toast.error(
            <p className="text-sm">
              {`Cannot connect to the server. Please ensure the server is running and CORS is configured correctly.`}
            </p>
          );
          return;
        } else {
          const message =
            error.response?.data?.msg ||
            error.response?.data?.message ||
            error.response?.data?.error ||
            "Something went wrong while deleting";
          toast.error(<p className="text-sm">{message}</p>);
        }
      }
    });
  };

  return { handleDelete };
}

export default useDeleteData;
export { useDeleteData2 };
